import React, { FC } from 'react';
import { Box, Divider, Pagination } from '@wix/design-system';
import { useRouter } from 'next/router';

type Props = {
  currentPage: number;
  numberOfPages: number;
  getPageUrl: (page: number) => string;
  onPageClicked: (page: number) => any;
  showTopDivider: boolean;
};

const PaginationFooter: FC<Props> = ({
  currentPage,
  numberOfPages,
  getPageUrl,
  onPageClicked,
  showTopDivider,
}) => {
  const router = useRouter();
  return (
    <>
      {showTopDivider && (
        <Box paddingTop="67px">
          <Divider skin="light" />
        </Box>
      )}
      <Box
        align="center"
        width="100%"
        marginTop="39px"
        marginBottom="27px"
        direction="vertical"
        dataHook="pagination-footer-container"
      >
        <Pagination
          dataHook="pagination"
          currentPage={currentPage}
          totalPages={numberOfPages}
          pageUrl={getPageUrl}
          onChange={({ page, event }) => {
            event.preventDefault();
            router.push(getPageUrl(page), undefined, {
              shallow: true,
            });

            onPageClicked(page);
          }}
        />
      </Box>
    </>
  );
};

export default PaginationFooter;
